import { Button } from '@lana-ui/login';
import Divider from '../Common/common/src/divider/Divider';
import "../../Statics/Scss/Features/ModalBodyExterior.scss";
import CallbackArticle from '../Common/login/src/callbackArticle/CallbackArticle';
import Paragraph from '../Common/common/src/paragraph/Paragraph';

const ModalBodyExterior = (props) => {
    const { onAccept } = props;

    return (
        <>
            <div className='row --jc-center contenido-body --font-regular'>
                <CallbackArticle
                    font="sueca"
                    title={
                        <div className='row --jc-center'>
                            <div className="col-deskxl-12 col-tablet-9 col-12">
                                La credencial Club LA NACION se emite solo para domicilios en Argentina.
                            </div>
                        </div>
                    }
                    description={
                        <div className='row --jc-center'>
                            <div className="col-deskxl-12 col-tablet-11 col-12">
                                <Paragraph size="xs">
                                    Si tu domicilio es del exterior, no recibirás la credencial de Club LA NACION. Podés ingresar un domicilio en Argentina para recibirla. Te recordamos que el uso de la misma es
                                    personal.
                                </Paragraph>
                            </div>
                        </div>
                    }
                />
            </div>
            <Divider />
            <Button tag="input" className="--not-disabled --mr-16" label="ACEPTAR" type="button" onClick={onAccept} mobileW100={true} />
        </>
    );
};

export default ModalBodyExterior;
